const finite = value => typeof value === 'number' && Number.isFinite(value);
const positive = value => finite(value) && value > 0;
const text = value => typeof value === 'string' && value.trim().length > 0;
const optionalText = value => value === null || typeof value === 'string';
const terms = ['tbw', 'ecw', 'icw'];

// Validate a read-only response, without calculating or repairing clinical values.
// Each reference retains its own status, version and dependencies for the UI.
export function validateWaterReference(result, measurementId, allow50KhzFallback = false) {
  const invalid = () => { throw new Error('Risposta del confronto idrico non valida. La misura salvata resta invariata.'); };
  if (!text(measurementId) || result?.measurementId !== measurementId ||
      !text(result.savedFormulaVersion) || !optionalText(result.patientContextVersion) ||
      !result.saved || !result.difference || !result.reference ||
      result.reference.isClinicalValidated !== false ||
      typeof result.canUse50KhzFallback !== 'boolean' || !text(result.warning)) invalid();

  for (const term of terms) {
    const ref = result.reference[term], saved = result.saved[`${term}Litres`];
    const difference = result.difference[`${term}Litres`];
    if (!ref || ref.isClinicalValidated !== false || !optionalText(ref.reason) ||
        !(saved === null || positive(saved))) invalid();
    if (ref.status === 'reference-only') {
      if (!positive(ref.litres) || !text(ref.formulaVersion)) invalid();
      if (saved === null ? difference !== null : !finite(difference)) invalid();
    } else if (ref.status === 'unavailable') {
      if (ref.litres !== null || difference !== null || !text(ref.reason) ||
          !optionalText(ref.formulaVersion)) invalid();
    } else invalid();
  }

  const { tbw, ecw, icw } = result.reference;
  if (ecw.status === 'reference-only') {
    if (![5, 50].includes(ecw.frequencyKhz) ||
        (ecw.frequencyKhz === 50 && allow50KhzFallback !== true) ||
        result.canUse50KhzFallback) invalid();
  } else if (ecw.frequencyKhz !== null) invalid();
  if (icw.status === 'reference-only' &&
      (tbw.status !== 'reference-only' || ecw.status !== 'reference-only')) invalid();
  if (allow50KhzFallback === true && result.canUse50KhzFallback) invalid();
  return result;
}
